/*
 * 姓名学笔画映射（简体/繁体/姓名学三口径中的“姓名学笔画”）
 * 数据来源：/Users/xiaodongliu/Downloads/轩书房/1-输入/3-专题笔记/国学/姓名学八十一数理/起名字库.md
 * 由 scripts/sync-nameology-data.mjs 自动生成，请勿手改。
 */

export const NAMEOLOGY_STROKE_MAP: Record<string, number> = {
  "阿": 13,
  "哀": 9,
  "埃": 10,
  "蔼": 22,
  "霭": 24,
  "艾": 8,
  "爱": 13,
  "隘": 18,
  "瑷": 18,
  "安": 6,
  "谙": 16,
  "鞍": 15,
  "岸": 8,
  "按": 10,
  "案": 10,
  "昂": 8,
  "凹": 5,
  "敖": 11,
  "熬": 15,
  "袄": 19,
  "奥": 13,
  "澳": 17,
  "八": 8,
  "巴": 4,
  "拔": 9,
  "坝": 24,
  "霸": 21,
  "白": 5,
  "百": 6,
  "佰": 8,
  "柏": 9,
  "班": 11,
  "般": 10,
  "颁": 13,
  "斑": 12,
  "阪": 12,
  "坂": 7,
  "板": 8,
  "版": 8,
  "半": 5,
  "伴": 7,
  "扮": 8,
  "邦": 11,
  "帮": 12,
  "榜": 14,
  "傍": 12,
  "棒": 12,
  "包": 5,
  "胞": 11,
  "褒": 15,
  "宝": 19,
  "保": 9,
  "堡": 12,
  "葆": 15,
  "报": 12,
  "抱": 9,
  "杯": 8,
  "碑": 13,
  "北": 5,
  "贝": 7,
  "背": 11,
  "倍": 10,
  "被": 11,
  "辈": 15,
  "蓓": 16,
  "呗": 10,
  "奔": 9,
  "本": 5,
  "比": 4,
  "彼": 8,
  "币": 15,
  "必": 5,
  "毕": 11,
  "闭": 11,
  "庇": 7,
  "陛": 15,
  "弼": 12,
  "碧": 14,
  "壁": 16,
  "嬖": 16,
  "薜": 19,
  "璧": 18,
  "边": 22,
  "编": 15,
  "卞": 4,
  "变": 23,
  "便": 9,
  "辨": 16,
  "辩": 21,
  "标": 15,
  "彪": 11,
  "表": 9,
  "别": 7,
  "宾": 14,
  "彬": 11,
  "斌": 11,
  "滨": 16,
  "缤": 20,
  "槟": 18,
  "镔": 22,
  "濒": 20,
  "膑": 20,
  "冰": 6,
  "兵": 7,
  "丙": 5,
  "柄": 9,
  "炳": 9,
  "禀": 13,
  "并": 8,
  "玻": 10,
  "播": 16,
  "蕃": 18,
  "伯": 7,
  "帛": 8,
  "勃": 9,
  "舶": 11,
  "博": 12,
  "擘": 17,
  "补": 13,
  "捕": 11,
  "不": 4,
  "布": 5,
  "步": 7,
  "钚": 21,
  "埔": 10,
  "部": 15,
  "埠": 11,
  "瓿": 12,
  "簿": 19,
  "才": 3,
  "材": 7,
  "财": 10,
  "采": 8,
  "彩": 11,
  "菜": 14,
  "蔡": 23,
  "参": 11,
  "粲": 13,
  "仓": 10,
  "沧": 14,
  "苍": 16,
  "藏": 20,
  "操": 17,
  "曹": 11,
  "册": 5,
  "测": 13,
  "岑": 7,
  "层": 15,
  "查": 9,
  "姹": 9,
  "差": 10,
  "侪": 16,
  "柴": 9,
  "蝉": 15,
  "铲": 19,
  "昌": 8,
  "菖": 14,
  "阊": 16,
  "肠": 15,
  "尝": 14,
  "偿": 17,
  "常": 11,
  "厂": 15,
  "畅": 14,
  "唱": 11,
  "巢": 11,
  "朝": 12,
  "潮": 16,
  "吵": 7,
  "车": 7,
  "澈": 16,
  "琛": 13,
  "尘": 14,
  "臣": 6,
  "辰": 7,
  "陈": 16,
  "宸": 10,
  "晨": 11,
  "谌": 16,
  "丞": 6,
  "成": 7,
  "呈": 7,
  "承": 8,
  "诚": 14,
  "城": 10,
  "乘": 10,
  "晟": 11,
  "橙": 16,
  "秤": 10,
  "吃": 6,
  "笞": 20,
  "池": 7,
  "驰": 13,
  "迟": 18,
  "持": 10,
  "尺": 4,
  "侈": 8,
  "耻": 10,
  "赤": 7,
  "充": 5,
  "冲": 6,
  "憧": 16,
  "虫": 6,
  "崇": 11,
  "仇": 4,
  "俦": 16,
  "绸": 14,
  "稠": 13,
  "筹": 20,
  "丑": 4,
  "出": 5,
  "初": 8,
  "厨": 15,
  "储": 18,
  "楮": 20,
  "楚": 13,
  "褚": 15,
  "处": 11,
  "畜": 10,
  "川": 3,
  "穿": 9,
  "传": 12,
  "船": 11,
  "钏": 11,
  "床": 7,
  "幢": 15,
  "吹": 7,
  "炊": 8,
  "垂": 8,
  "陲": 16,
  "春": 9,
  "椿": 13,
  "纯": 10,
  "莼": 16,
  "鹑": 19,
  "醇": 15,
  "绰": 14,
  "辍": 15,
  "慈": 14,
  "磁": 15,
  "雌": 13,
  "糍": 14,
  "此": 6,
  "次": 6,
  "伺": 7,
  "刺": 8,
  "赐": 15,
  "聪": 16,
  "从": 11,
  "丛": 18,
  "凑": 13,
  "粗": 15,
  "促": 9,
  "簇": 17,
  "崔": 11,
  "催": 13,
  "摧": 15,
  "粹": 14,
  "翠": 14,
  "村": 7,
  "存": 6,
  "寸": 3,
  "厝": 10,
  "错": 16,
  "达": 16,
  "妲": 8,
  "沓": 8,
  "打": 6,
  "大": 3,
  "呆": 7,
  "逮": 15,
  "代": 5,
  "岱": 8,
  "骀": 15,
  "带": 11,
  "待": 9,
  "怠": 9,
  "玳": 10,
  "贷": 12,
  "戴": 18,
  "黛": 17,
  "丹": 4,
  "单": 12,
  "担": 17,
  "眈": 9,
  "旦": 5,
  "弹": 15,
  "惮": 16,
  "淡": 12,
  "当": 13,
  "铛": 21,
  "挡": 17,
  "党": 20,
  "宕": 8,
  "刀": 2,
  "导": 16,
  "祷": 19,
  "到": 8,
  "倒": 10,
  "道": 16,
  "稻": 15,
  "得": 11,
  "德": 15,
  "地": 6,
  "的": 8,
  "灯": 6,
  "邓": 19,
  "低": 7,
  "堤": 12,
  "滴": 15,
  "迪": 12,
  "敌": 15,
  "涤": 15,
  "嫡": 14,
  "诋": 15,
  "底": 8,
  "弟": 7,
  "帝": 9,
  "递": 17,
  "第": 11,
  "谛": 16,
  "缔": 15,
  "蒂": 15,
  "滇": 14,
  "典": 8,
  "点": 17,
  "电": 13,
  "佃": 7,
  "甸": 7,
  "店": 8,
  "奠": 12,
  "殿": 12,
  "刁": 2,
  "雕": 16,
  "吊": 6,
  "钓": 11,
  "调": 15,
  "爹": 10,
  "喋": 12,
  "叠": 22,
  "蝶": 15,
  "丁": 2,
  "叮": 5,
  "钉": 10,
  "酊": 9,
  "顶": 11,
  "鼎": 13,
  "订": 9,
  "定": 8,
  "锭": 16,
  "东": 8,
  "冬": 5,
  "董": 15,
  "动": 11,
  "侗": 8,
  "恫": 10,
  "洞": 10,
  "都": 16,
  "斗": 4,
  "豆": 7,
  "窦": 20,
  "读": 22,
  "笃": 16,
  "堵": 12,
  "杜": 7,
  "肚": 9,
  "度": 9,
  "渡": 12,
  "镀": 17,
  "端": 14,
  "段": 9,
  "断": 18,
  "锻": 17,
  "堆": 11,
  "队": 17,
  "对": 14,
  "敦": 12,
  "墩": 15,
  "镦": 20,
  "顿": 13,
  "铎": 21,
  "朵": 6,
  "舵": 11,
  "俄": 9,
  "峨": 10,
  "蛾": 13,
  "额": 18,
  "恩": 10,
  "蒽": 15,
  "儿": 7,
  "而": 6,
  "尔": 14,
  "耳": 6,
  "迩": 21,
  "二": 2,
  "发": 12,
  "乏": 5,
  "伐": 6,
  "罚": 15,
  "阀": 14,
  "法": 9,
  "帆": 6,
  "番": 12,
  "幡": 15,
  "藩": 21,
  "凡": 3,
  "烦": 13,
  "樊": 15,
  "繁": 17,
  "反": 4,
  "返": 11,
  "泛": 9,
  "饭": 13,
  "范": 11,
  "贩": 11,
  "方": 4,
  "坊": 7,
  "芳": 10,
  "防": 12,
  "房": 8,
  "肪": 10,
  "访": 11,
  "纺": 10,
  "放": 8,
  "飞": 9,
  "妃": 6,
  "非": 8,
  "扉": 12,
  "肥": 10,
  "淝": 12,
  "翡": 14,
  "废": 15,
  "肺": 10,
  "费": 12,
  "分": 4,
  "坟": 15,
  "汾": 8,
  "粉": 10,
  "份": 6,
  "奋": 16,
  "丰": 18,
  "风": 9,
  "沣": 22,
  "枫": 13,
  "封": 9,
  "峰": 10,
  "烽": 11,
  "锋": 15,
  "蜂": 13,
  "逢": 14,
  "讽": 16,
  "凤": 14,
  "奉": 8,
  "俸": 10,
  "缝": 17,
  "夫": 4,
  "弗": 5,
  "伏": 5,
  "佛": 7,
  "孚": 7,
  "扶": 8,
  "芙": 10,
  "符": 11,
  "幅": 12,
  "福": 14,
  "抚": 16,
  "甫": 7,
  "府": 8,
  "俯": 10,
  "辅": 14,
  "腑": 13,
  "滏": 14,
  "付": 5,
  "妇": 11,
  "负": 9,
  "附": 13,
  "阜": 8,
  "复": 12,
  "赴": 9,
  "副": 11,
  "傅": 12,
  "富": 12,
  "赋": 15,
  "腹": 15,
  "馥": 18,
  "该": 13,
  "改": 7,
  "盖": 16,
  "溉": 15,
  "概": 15,
  "甘": 5,
  "杆": 7,
  "肝": 9,
  "柑": 9,
  "敢": 12,
  "感": 13,
  "橄": 16,
  "干": 3,
  "淦": 12,
  "赣": 24,
  "冈": 8,
  "刚": 10,
  "纲": 14,
  "钢": 16,
  "岗": 11,
  "港": 13,
  "戆": 25,
  "皋": 10,
  "高": 10,
  "膏": 16,
  "篙": 16,
  "糕": 16,
  "稿": 15,
  "告": 7,
  "诰": 14,
  "锆": 15,
  "哥": 10,
  "歌": 14,
  "革": 9,
  "格": 10,
  "葛": 15,
  "个": 10,
  "各": 6,
  "铬": 14,
  "给": 12,
  "根": 10,
  "艮": 6,
  "庚": 8,
  "耕": 10,
  "耿": 10,
  "梗": 11,
  "更": 7,
  "工": 3,
  "弓": 3,
  "公": 4,
  "攻": 7,
  "供": 8,
  "宫": 10,
  "恭": 10,
  "拱": 10,
  "珙": 11,
  "共": 6,
  "贡": 10,
  "勾": 4,
  "沟": 14,
  "构": 14,
  "购": 16,
  "够": 11,
  "估": 7,
  "姑": 8,
  "辜": 12,
  "古": 5,
  "谷": 7,
  "股": 10,
  "鼓": 13,
  "嘏": 14,
  "固": 8,
  "故": 9,
  "顾": 21,
  "瓜": 5,
  "卦": 8,
  "挂": 10,
  "关": 18,
  "观": 25,
  "官": 8,
  "冠": 9,
  "莞": 13,
  "馆": 17,
  "管": 14,
  "贯": 11,
  "惯": 15,
  "灌": 22,
  "鹳": 29,
  "罐": 24,
  "光": 6,
  "广": 15,
  "归": 18,
  "圭": 6,
  "龟": 16,
  "规": 11,
  "皈": 9,
  "闺": 14,
  "瑰": 15,
  "轨": 9,
  "癸": 9,
  "柜": 18,
  "贵": 12,
  "桂": 10,
  "桧": 17,
  "郭": 15,
  "国": 11,
  "果": 8,
  "哈": 9,
  "还": 20,
  "孩": 9,
  "海": 11,
  "亥": 6,
  "害": 10,
  "酣": 12,
  "含": 7,
  "邯": 12,
  "函": 8,
  "涵": 12,
  "寒": 12,
  "韩": 17,
  "汉": 15,
  "旱": 7,
  "瀚": 20,
  "杭": 8,
  "航": 10,
  "毫": 11,
  "豪": 14,
  "壕": 17,
  "好": 6,
  "郝": 14,
  "号": 13,
  "浩": 11,
  "皓": 11,
  "灏": 25,
  "禾": 5,
  "合": 6,
  "何": 7,
  "和": 8,
  "河": 9,
  "荷": 13,
  "盒": 11,
  "贺": 12,
  "鹤": 21,
  "黑": 12,
  "哼": 11,
  "恒": 10,
  "珩": 11,
  "横": 16,
  "衡": 16,
  "轰": 21,
  "弘": 5,
  "红": 9,
  "宏": 7,
  "泓": 9,
  "洪": 10,
  "荭": 15,
  "虹": 9,
  "鸿": 17,
  "侯": 9,
  "后": 6,
  "厚": 9,
  "乎": 5,
  "忽": 8,
  "胡": 11,
  "壶": 11,
  "湖": 13,
  "瑚": 14,
  "虎": 8,
  "浒": 15,
  "琥": 13,
  "互": 4,
  "户": 4,
  "沪": 15,
  "祜": 10,
  "花": 10,
  "哗": 15,
  "华": 14,
  "铧": 20,
  "滑": 14,
  "化": 4,
  "划": 15,
  "画": 11,
  "话": 13,
  "桦": 16,
  "怀": 20,
  "淮": 12,
  "槐": 14,
  "坏": 20,
  "欢": 22,
  "环": 7,
  "洹": 10,
  "桓": 10,
  "锾": 17,
  "缓": 15,
  "幻": 4,
  "奂": 9,
  "宦": 9,
  "换": 13,
  "浣": 11,
  "涣": 13,
  "患": 11,
  "焕": 13,
  "皇": 9,
  "凰": 11,
  "黄": 12,
  "徨": 12,
  "惶": 13,
  "恍": 10,
  "晃": 10,
  "灰": 6,
  "恢": 10,
  "挥": 13,
  "辉": 15,
  "麾": 15,
  "回": 6,
  "卉": 5,
  "汇": 13,
  "讳": 16,
  "绘": 19,
  "惠": 12,
  "慧": 15,
  "昏": 8,
  "婚": 11,
  "浑": 13,
  "珲": 14,
  "混": 12,
  "活": 10,
  "火": 4,
  "或": 8,
  "货": 11,
  "获": 13,
  "镬": 22,
  "机": 6,
  "矶": 17,
  "鸡": 21,
  "姬": 9,
  "积": 16,
  "基": 11,
  "箕": 14,
  "稽": 15,
  "激": 17,
  "及": 4,
  "吉": 6,
  "级": 10,
  "即": 7,
  "极": 13,
  "亟": 8,
  "急": 9,
  "集": 12,
  "辑": 16,
  "藉": 20,
  "籍": 20,
  "几": 15,
  "己": 3,
  "挤": 18,
  "掎": 12,
  "计": 9,
  "记": 10,
  "伎": 6,
  "纪": 9,
  "妓": 7,
  "技": 8,
  "际": 19,
  "季": 8,
  "济": 18,
  "迹": 13,
  "寄": 11,
  "祭": 11,
  "绩": 17,
  "暨": 16,
  "稷": 15,
  "骥": 27,
  "加": 5,
  "伽": 7,
  "佳": 8,
  "茄": 11,
  "迦": 12,
  "颊": 16,
  "甲": 5,
  "贾": 13,
  "假": 11,
  "价": 6,
  "驾": 15,
  "架": 9,
  "嫁": 13,
  "奸": 6,
  "尖": 6,
  "坚": 11,
  "间": 12,
  "肩": 10,
  "兼": 10,
  "监": 14,
  "俭": 15,
  "捡": 17,
  "剪": 11,
  "简": 18,
  "翦": 15,
  "见": 7,
  "件": 6,
  "建": 9,
  "剑": 15,
  "荐": 19,
  "健": 11,
  "舰": 20,
  "渐": 15,
  "践": 15,
  "鉴": 15,
  "键": 17,
  "箭": 15,
  "江": 7,
  "姜": 9,
  "将": 11,
  "浆": 15,
  "疆": 16,
  "讲": 17,
  "奖": 14,
  "蒋": 17,
  "匠": 6,
  "交": 6,
  "姣": 9,
  "胶": 17,
  "椒": 12,
  "焦": 12,
  "蛟": 12,
  "蕉": 18,
  "角": 7,
  "侥": 14,
  "皎": 11,
  "叫": 5,
  "轿": 19,
  "教": 11,
  "阶": 17,
  "皆": 9,
  "接": 12,
  "街": 12,
  "节": 15,
  "杰": 8,
  "洁": 16,
  "桔": 10,
  "捷": 12,
  "姐": 8,
  "解": 13,
  "介": 4,
  "届": 8,
  "界": 9,
  "借": 10,
  "巾": 3,
  "今": 4,
  "斤": 4,
  "金": 8,
  "津": 10,
  "襟": 19,
  "仅": 13,
  "尽": 16,
  "紧": 14,
  "谨": 18,
  "锦": 16,
  "瑾": 16,
  "劲": 9,
  "近": 11,
  "进": 15,
  "晋": 10,
  "缙": 16,
  "京": 8,
  "经": 13,
  "茎": 13,
  "菁": 14,
  "晶": 12,
  "兢": 14,
  "精": 14,
  "鲸": 19,
  "井": 4,
  "景": 12,
  "警": 20,
  "净": 12,
  "径": 10,
  "竞": 20,
  "婧": 11,
  "竟": 11,
  "敬": 13,
  "靖": 13,
  "静": 16,
  "镜": 19,
  "纠": 8,
  "究": 7,
  "九": 9,
  "久": 3,
  "玖": 8,
  "酒": 10,
  "旧": 18,
  "臼": 6,
  "救": 11,
  "就": 11,
  "僦": 14,
  "居": 8,
  "局": 7,
  "橘": 16,
  "举": 17,
  "矩": 10,
  "莒": 13,
  "巨": 5,
  "句": 5,
  "拒": 9,
  "具": 8,
  "钜": 13,
  "俱": 10,
  "剧": 15,
  "据": 17,
  "娟": 10,
  "捐": 11,
  "卷": 8,
  "绢": 13,
  "眷": 11,
  "决": 6,
  "诀": 11,
  "觉": 19,
  "掘": 12,
  "爵": 18,
  "军": 9,
  "君": 7,
  "均": 7,
  "钧": 12,
  "俊": 9,
  "峻": 10,
  "骏": 17,
  "卡": 4,
  "开": 12,
  "凯": 12,
  "恺": 14,
  "楷": 13,
  "刊": 5,
  "勘": 11,
  "坎": 7,
  "侃": 8,
  "砍": 9,
  "看": 9,
  "阚": 20,
  "瞰": 17,
  "康": 11,
  "慷": 15,
  "糠": 17,
  "亢": 4,
  "伉": 6,
  "抗": 8,
  "考": 6,
  "靠": 15,
  "柯": 9,
  "科": 9,
  "可": 5,
  "岢": 8,
  "克": 7,
  "刻": 8,
  "客": 9,
  "课": 15,
  "肯": 10,
  "垦": 16,
  "恳": 17,
  "铿": 19,
  "空": 8,
  "孔": 4,
  "口": 3,
  "扣": 7,
  "寇": 11,
  "苦": 11,
  "库": 8,
  "夸": 13,
  "块": 13,
  "快": 8,
  "宽": 15,
  "款": 12,
  "匡": 6,
  "筐": 12,
  "圹": 18,
  "纩": 18,
  "况": 7,
  "矿": 20,
  "岿": 20,
  "窥": 16,
  "奎": 9,
  "逵": 15,
  "揆": 13,
  "葵": 15,
  "魁": 14,
  "匮": 13,
  "愧": 14,
  "蒉": 18,
  "坤": 8,
  "昆": 8,
  "琨": 13,
  "扩": 19,
  "廓": 14,
  "拉": 9,
  "来": 8,
  "崃": 11,
  "徕": 11,
  "莱": 14,
  "赖": 16,
  "濑": 20,
  "籁": 22,
  "兰": 23,
  "岚": 12,
  "栏": 21,
  "蓝": 20,
  "斓": 21,
  "篮": 20,
  "览": 21,
  "廊": 13,
  "榔": 14,
  "朗": 11,
  "浪": 11,
  "劳": 12,
  "老": 6,
  "佬": 8,
  "烙": 10,
  "乐": 15,
  "了": 2,
  "勒": 19,
  "雷": 13,
  "镭": 21,
  "垒": 18,
  "类": 19,
  "累": 11,
  "冷": 7,
  "厘": 9,
  "骊": 29,
  "梨": 11,
  "鹂": 30,
  "黎": 15,
  "篱": 25,
  "藜": 18,
  "礼": 18,
  "李": 7,
  "里": 7,
  "理": 12,
  "鲤": 18,
  "力": 2,
  "历": 16,
  "厉": 15,
  "立": 5,
  "吏": 6,
  "丽": 19,
  "利": 7,
  "励": 13,
  "沥": 20,
  "苈": 22,
  "例": 8,
  "枥": 20,
  "俐": 9,
  "俪": 21,
  "栎": 19,
  "荔": 12,
  "栗": 10,
  "莅": 13,
  "莉": 13,
  "雳": 24,
  "俩": 10,
  "奁": 14,
  "连": 14,
  "莲": 17,
  "联": 17,
  "练": 15,
  "恋": 23,
  "链": 19,
  "良": 7,
  "梁": 11,
  "粮": 18,
  "两": 8,
  "亮": 9,
  "谅": 15,
  "量": 12,
  "辽": 19,
  "僚": 14,
  "料": 10,
  "廖": 14,
  "列": 6,
  "劣": 6,
  "冽": 8,
  "烈": 10,
  "邻": 19,
  "林": 8,
  "临": 17,
  "琳": 13,
  "嶙": 15,
  "霖": 16,
  "磷": 17,
  "鳞": 19,
  "吝": 7,
  "伶": 7,
  "灵": 24,
  "苓": 11,
  "玲": 10,
  "凌": 10,
  "铃": 13,
  "陵": 16,
  "绫": 14,
  "翎": 11,
  "岭": 8,
  "领": 14,
  "令": 5,
  "另": 5,
  "溜": 14,
  "刘": 15,
  "流": 10,
  "留": 10,
  "柳": 9,
  "六": 6,
  "泷": 20,
  "笼": 22,
  "隆": 17,
  "陇": 24,
  "垄": 22,
  "拢": 20,
  "娄": 11,
  "楼": 15,
  "庐": 16,
  "芦": 22,
  "炉": 8,
  "鲁": 15,
  "橹": 19,
  "陆": 16,
  "录": 16,
  "路": 13,
  "潞": 17,
  "璐": 18,
  "麓": 19,
  "露": 20,
  "驴": 26,
  "闾": 15,
  "侣": 9,
  "旅": 10,
  "铝": 15,
  "屡": 14,
  "履": 15,
  "律": 9,
  "虑": 15,
  "绿": 14,
  "滤": 20,
  "鸾": 30,
  "銮": 27,
  "略": 11,
  "伦": 10,
  "囵": 11,
  "纶": 14,
  "轮": 15,
  "论": 15,
  "罗": 20,
  "逻": 26,
  "泺": 19,
  "洛": 10,
  "骆": 16,
  "落": 15,
  "麻": 11,
  "马": 10,
  "玛": 15,
  "码": 15,
  "埋": 10,
  "买": 12,
  "迈": 20,
  "麦": 11,
  "卖": 15,
  "脉": 12,
  "鳗": 22,
  "曼": 11,
  "慢": 15,
  "漫": 15,
  "蔓": 17,
  "镘": 19,
  "忙": 7,
  "盲": 8,
  "毛": 4,
  "矛": 5,
  "茅": 11,
  "锚": 16,
  "卯": 5,
  "冒": 9,
  "贸": 12,
  "帽": 12,
  "枚": 8,
  "玫": 9,
  "眉": 9,
  "梅": 11,
  "媒": 12,
  "嵋": 12,
  "楣": 13,
  "煤": 13,
  "每": 7,
  "美": 9,
  "媚": 12,
  "门": 8,
  "们": 10,
  "盟": 13,
  "蒙": 16,
  "朦": 20,
  "孟": 8,
  "梦": 14,
  "弥": 17,
  "祢": 19,
  "米": 6,
  "泌": 9,
  "觅": 11,
  "秘": 10,
  "密": 11,
  "蜜": 14,
  "眠": 10,
  "绵": 14,
  "棉": 12,
  "免": 7,
  "勉": 9,
  "娩": 10,
  "冕": 11,
  "眄": 9,
  "面": 9,
  "苗": 11,
  "描": 13,
  "秒": 9,
  "淼": 12,
  "渺": 13,
  "庙": 15,
  "民": 5,
  "珉": 10,
  "皿": 5,
  "闵": 12,
  "敏": 11,
  "名": 6,
  "明": 8,
  "鸣": 14,
  "茗": 12,
  "铭": 14,
  "酩": 13,
  "命": 8,
  "馍": 19,
  "模": 15,
  "摩": 15,
  "磨": 16,
  "末": 5,
  "陌": 14,
  "莫": 13,
  "漠": 15,
  "墨": 15,
  "默": 16,
  "牟": 6,
  "谋": 16,
  "某": 9,
  "母": 5,
  "亩": 10,
  "牡": 7,
  "木": 4,
  "目": 5,
  "沐": 8,
  "牧": 8,
  "募": 13,
  "幕": 13,
  "睦": 13,
  "慕": 15,
  "暮": 15,
  "拿": 10,
  "那": 11,
  "纳": 10,
  "娜": 10,
  "钠": 13,
  "乃": 2,
  "奶": 5,
  "奈": 8,
  "耐": 9,
  "男": 7,
  "南": 9,
  "楠": 12,
  "瑙": 14,
  "呢": 8,
  "内": 4,
  "嫩": 14,
  "妮": 8,
  "尼": 5,
  "倪": 10,
  "霓": 16,
  "你": 7,
  "拟": 18,
  "拈": 8,
  "年": 6,
  "念": 8,
  "娘": 10,
  "酿": 24,
  "鸟": 10,
  "柠": 18,
  "泞": 18,
  "妞": 7,
  "牛": 4,
  "纽": 10,
  "钮": 12,
  "农": 13,
  "侬": 15,
  "浓": 17,
  "弄": 7,
  "奴": 5,
  "努": 7,
  "女": 3,
  "暖": 12,
  "诺": 16,
  "讴": 18,
  "欧": 15,
  "偶": 11,
  "藕": 21,
  "杷": 8,
  "琶": 13,
  "怕": 9,
  "排": 12,
  "牌": 12,
  "派": 10,
  "潘": 16,
  "攀": 19,
  "盘": 15,
  "磐": 15,
  "判": 7,
  "叛": 9,
  "畔": 10,
  "庞": 18,
  "旁": 10,
  "胖": 11,
  "袍": 11,
  "泡": 9,
  "炮": 10,
  "陪": 16,
  "培": 11,
  "裴": 14,
  "沛": 8,
  "佩": 8,
  "配": 10,
  "盆": 9,
  "朋": 8,
  "彭": 12,
  "棚": 12,
  "鹏": 19,
  "篷": 17,
  "丕": 5,
  "劈": 15,
  "皮": 5,
  "枇": 8,
  "匹": 4,
  "疋": 5,
  "癖": 21,
  "偏": 12,
  "篇": 15,
  "片": 4,
  "飘": 20,
  "票": 11,
  "漂": 15,
  "嫔": 17,
  "品": 9,
  "聘": 13,
  "平": 5,
  "评": 12,
  "凭": 16,
  "坪": 8,
  "苹": 11,
  "屏": 9,
  "枰": 9,
  "瓶": 11,
  "萍": 14,
  "坡": 8,
  "颇": 14,
  "婆": 11,
  "迫": 12,
  "破": 10,
  "仆": 4,
  "匍": 9,
  "菩": 14,
  "葡": 15,
  "蒲": 16,
  "朴": 6,
  "圃": 10,
  "普": 12,
  "谱": 19,
  "铺": 15,
  "瀑": 19,
  "七": 2,
  "妻": 8,
  "漆": 15,
  "齐": 14,
  "岐": 7,
  "其": 8,
  "奇": 8,
  "祈": 9,
  "俟": 9,
  "脐": 20,
  "崎": 11,
  "骑": 15,
  "琦": 13,
  "琪": 13,
  "祺": 13,
  "旗": 14,
  "乞": 3,
  "企": 6,
  "启": 11,
  "杞": 7,
  "起": 10,
  "绮": 14,
  "气": 10,
  "讫": 10,
  "器": 16,
  "恰": 10,
  "洽": 8,
  "千": 3,
  "仟": 5,
  "阡": 11,
  "迁": 19,
  "铅": 13,
  "谦": 13,
  "搴": 14,
  "前": 9,
  "虔": 10,
  "钱": 16,
  "乾": 11,
  "倩": 10,
  "锵": 19,
  "强": 11,
  "悄": 11,
  "侨": 14,
  "桥": 16,
  "谯": 19,
  "樵": 16,
  "巧": 5,
  "俏": 9,
  "且": 5,
  "切": 4,
  "妾": 8,
  "挈": 10,
  "亲": 16,
  "侵": 9,
  "芩": 10,
  "秦": 10,
  "琴": 13,
  "勤": 13,
  "沁": 8,
  "青": 8,
  "轻": 14,
  "卿": 11,
  "顷": 11,
  "请": 15,
  "庆": 15,
  "磬": 18,
  "穷": 15,
  "琼": 13,
  "丘": 5,
  "秋": 9,
  "楸": 13,
  "求": 5,
  "逑": 14,
  "区": 11,
  "曲": 6,
  "岖": 14,
  "屈": 8,
  "劬": 7,
  "取": 8,
  "娶": 11,
  "去": 5,
  "趣": 15,
  "全": 6,
  "诠": 13,
  "泉": 9,
  "拳": 10,
  "铨": 14,
  "券": 8,
  "却": 7,
  "雀": 11,
  "确": 15,
  "裙": 13,
  "群": 13,
  "冉": 5,
  "染": 9,
  "壤": 20,
  "攘": 21,
  "热": 15,
  "人": 2,
  "仁": 4,
  "壬": 4,
  "忍": 7,
  "稔": 13,
  "认": 14,
  "仞": 5,
  "任": 6,
  "妊": 9,
  "仍": 4,
  "日": 4,
  "荣": 14,
  "容": 10,
  "溶": 14,
  "蓉": 16,
  "榕": 14,
  "融": 16,
  "柔": 9,
  "肉": 6,
  "如": 6,
  "儒": 16,
  "汝": 7,
  "乳": 8,
  "入": 2,
  "洳": 10,
  "阮": 12,
  "蕊": 18,
  "锐": 15,
  "瑞": 14,
  "润": 16,
  "若": 11,
  "萨": 20,
  "塞": 13,
  "赛": 16,
  "三": 3,
  "桑": 10,
  "颡": 19,
  "色": 6,
  "瑟": 14,
  "沙": 8,
  "纱": 10,
  "刹": 8,
  "砂": 9,
  "莎": 13,
  "裟": 13,
  "厦": 13,
  "山": 3,
  "杉": 7,
  "姗": 8,
  "珊": 10,
  "闪": 10,
  "汕": 7,
  "擅": 17,
  "商": 11,
  "赏": 15,
  "上": 3,
  "尚": 8,
  "裳": 14,
  "勺": 3,
  "韶": 14,
  "少": 4,
  "劭": 7,
  "邵": 7,
  "绍": 11,
  "畲": 12,
  "舌": 6,
  "佘": 7,
  "舍": 8,
  "设": 11,
  "社": 8,
  "射": 10,
  "赦": 11,
  "谁": 15,
  "申": 5,
  "伸": 7,
  "身": 7,
  "绅": 11,
  "什": 4,
  "神": 10,
  "沈": 8,
  "审": 15,
  "渖": 19,
  "肾": 14,
  "甚": 9,
  "慎": 14,
  "升": 4,
  "生": 5,
  "声": 17,
  "牲": 10,
  "笙": 11,
  "绳": 19,
  "省": 9,
  "圣": 13,
  "师": 10,
  "诗": 13,
  "施": 9,
  "狮": 14,
  "湿": 18,
  "十": 2,
  "石": 5,
  "时": 10,
  "识": 19,
  "实": 14,
  "拾": 10,
  "食": 9,
  "莳": 16,
  "史": 5,
  "使": 8,
  "始": 8,
  "士": 3,
  "氏": 4,
  "世": 5,
  "仕": 5,
  "市": 5,
  "示": 5,
  "式": 6,
  "事": 8,
  "侍": 8,
  "势": 13,
  "试": 13,
  "饰": 14,
  "室": 9,
  "拭": 10,
  "是": 9,
  "适": 18,
  "轼": 13,
  "释": 20,
  "筮": 13,
  "誓": 14,
  "匙": 11,
  "收": 6,
  "手": 4,
  "守": 6,
  "首": 9,
  "寿": 14,
  "受": 8,
  "狩": 10,
  "兽": 13,
  "售": 11,
  "书": 10,
  "抒": 8,
  "纾": 10,
  "枢": 15,
  "姝": 9,
  "殊": 10,
  "输": 13,
  "孰": 11,
  "塾": 14,
  "熟": 15,
  "署": 15,
  "蜀": 13,
  "曙": 18,
  "术": 11,
  "束": 7,
  "树": 16,
  "竖": 15,
  "恕": 10,
  "庶": 11,
  "数": 15,
  "墅": 14,
  "澍": 16,
  "刷": 8,
  "甩": 5,
  "帅": 9,
  "双": 18,
  "霜": 17,
  "孀": 20,
  "爽": 15,
  "水": 4,
  "睡": 13,
  "说": 14,
  "朔": 10,
  "铄": 23,
  "硕": 14,
  "司": 5,
  "私": 7,
  "思": 9,
  "厮": 15,
  "巳": 3,
  "四": 4,
  "寺": 6,
  "汜": 7,
  "姒": 8,
  "饲": 14,
  "驷": 15,
  "嗣": 13,
  "松": 8,
  "崧": 11,
  "淞": 12,
  "菘": 14,
  "嵩": 13,
  "讼": 11,
  "宋": 7,
  "诵": 14,
  "送": 13,
  "颂": 13,
  "叟": 10,
  "俗": 9,
  "夙": 6,
  "素": 10,
  "速": 14,
  "宿": 11,
  "溯": 14,
  "算": 14,
  "虽": 17,
  "隋": 17,
  "随": 21,
  "岁": 13,
  "遂": 16,
  "燧": 17,
  "穗": 17,
  "孙": 10,
  "所": 8,
  "索": 10,
  "锁": 18,
  "他": 5,
  "塔": 12,
  "拓": 9,
  "台": 5,
  "抬": 18,
  "太": 4,
  "汰": 8,
  "滩": 23,
  "坛": 16,
  "昙": 16,
  "谈": 15,
  "谭": 19,
  "潭": 16,
  "坦": 8,
  "炭": 9,
  "探": 12,
  "汤": 12,
  "唐": 10,
  "堂": 11,
  "棠": 12,
  "塘": 12,
  "膛": 17,
  "倘": 10,
  "涛": 18,
  "掏": 12,
  "桃": 10,
  "陶": 16,
  "淘": 12,
  "讨": 10,
  "套": 10,
  "特": 10,
  "腾": 20,
  "藤": 21,
  "梯": 11,
  "提": 13,
  "题": 18,
  "蹄": 16,
  "体": 7,
  "屉": 8,
  "倜": 10,
  "悌": 11,
  "替": 12,
  "天": 4,
  "添": 12,
  "田": 5,
  "恬": 10,
  "甜": 11,
  "忝": 8,
  "佻": 8,
  "挑": 10,
  "条": 11,
  "迢": 12,
  "窕": 11,
  "帖": 8,
  "铁": 21,
  "厅": 25,
  "汀": 6,
  "听": 22,
  "廷": 7,
  "亭": 9,
  "庭": 10,
  "停": 11,
  "婷": 12,
  "葶": 15,
  "霆": 15,
  "町": 7,
  "挺": 11,
  "梃": 11,
  "通": 14,
  "仝": 5,
  "同": 6,
  "佟": 7,
  "彤": 7,
  "桐": 10,
  "瞳": 17,
  "桶": 11,
  "头": 16,
  "投": 8,
  "凸": 5,
  "突": 9,
  "图": 14,
  "徒": 10,
  "涂": 13,
  "屠": 12,
  "土": 3,
  "兔": 8,
  "湍": 13,
  "团": 14,
  "推": 12,
  "腿": 16,
  "退": 13,
  "吞": 7,
  "屯": 4,
  "托": 7,
  "陀": 13,
  "沱": 9,
  "驼": 15,
  "柁": 9,
  "娃": 9,
  "瓦": 5,
  "哇": 9,
  "外": 5,
  "湾": 26,
  "丸": 3,
  "完": 7,
  "宛": 8,
  "婉": 11,
  "晚": 11,
  "菀": 14,
  "琬": 12,
  "畹": 13,
  "碗": 13,
  "万": 15,
  "汪": 8,
  "王": 4,
  "往": 8,
  "忘": 7,
  "旺": 8,
  "威": 9,
  "葳": 15,
  "薇": 19,
  "韦": 9,
  "围": 12,
  "帏": 12,
  "闱": 17,
  "唯": 11,
  "帷": 11,
  "惟": 12,
  "潍": 18,
  "伟": 11,
  "尾": 7,
  "纬": 15,
  "苇": 15,
  "委": 8,
  "炜": 13,
  "玮": 14,
  "隗": 18,
  "卫": 15,
  "为": 12,
  "未": 5,
  "位": 7,
  "味": 8,
  "畏": 9,
  "胃": 9,
  "尉": 11,
  "谓": 16,
  "渭": 13,
  "蔚": 17,
  "慰": 15,
  "温": 14,
  "文": 4,
  "纹": 10,
  "玟": 9,
  "闻": 14,
  "蚊": 10,
  "雯": 12,
  "吻": 7,
  "稳": 19,
  "问": 11,
  "翁": 10,
  "蓊": 13,
  "我": 7,
  "沃": 8,
  "卧": 8,
  "幄": 12,
  "握": 13,
  "渥": 13,
  "斡": 14,
  "巫": 7,
  "屋": 9,
  "吴": 7,
  "吾": 7,
  "梧": 11,
  "五": 5,
  "午": 4,
  "伍": 6,
  "妩": 15,
  "武": 8,
  "舞": 14,
  "兀": 3,
  "勿": 4,
  "务": 11,
  "戊": 5,
  "物": 8,
  "悟": 11,
  "婺": 12,
  "雾": 19,
  "夕": 3,
  "吸": 7,
  "汐": 7,
  "西": 6,
  "希": 7,
  "昔": 8,
  "析": 8,
  "奚": 10,
  "息": 10,
  "悉": 11,
  "犀": 11,
  "溪": 14,
  "锡": 16,
  "僖": 14,
  "熙": 14,
  "膝": 17,
  "熹": 16,
  "曦": 20,
  "习": 11,
  "席": 10,
  "玺": 19,
  "喜": 14,
  "禧": 17,
  "戏": 17,
  "系": 6,
  "细": 11,
  "侠": 9,
  "峡": 10,
  "霞": 17,
  "下": 3,
  "夏": 10,
  "仙": 5,
  "先": 6,
  "鲜": 17,
  "暹": 19,
  "弦": 8,
  "贤": 15,
  "咸": 9,
  "娴": 15,
  "舷": 11,
  "衔": 14,
  "显": 23,
  "险": 21,
  "线": 15,
  "限": 14,
  "宪": 16,
  "献": 20,
  "乡": 17,
  "相": 9,
  "香": 9,
  "湘": 13,
  "箱": 15,
  "襄": 17,
  "骧": 27,
  "镶": 25,
  "详": 13,
  "祥": 11,
  "翔": 12,
  "享": 8,
  "想": 13,
  "向": 6,
  "巷": 9,
  "像": 14,
  "橡": 16,
  "宵": 10,
  "消": 11,
  "逍": 14,
  "萧": 18,
  "销": 15,
  "霄": 15,
  "小": 3,
  "晓": 16,
  "孝": 7,
  "肖": 9,
  "校": 10,
  "啸": 15,
  "些": 7,
  "协": 8,
  "偕": 11,
  "谐": 16,
  "械": 11,
  "薤": 19,
  "蟹": 19,
  "心": 4,
  "欣": 8,
  "新": 13,
  "薪": 19,
  "馨": 20,
  "信": 9,
  "星": 9,
  "行": 6,
  "邢": 11,
  "形": 7,
  "型": 9,
  "荥": 14,
  "醒": 16,
  "兴": 15,
  "杏": 7,
  "姓": 8,
  "幸": 8,
  "性": 9,
  "兄": 5,
  "熊": 14,
  "休": 6,
  "修": 10,
  "羞": 11,
  "秀": 7,
  "岫": 8,
  "绣": 13,
  "袖": 11,
  "锈": 20,
  "吁": 30,
  "戌": 6,
  "需": 14,
  "徐": 10,
  "诩": 13,
  "旭": 6,
  "序": 7,
  "叙": 11,
  "绪": 15,
  "续": 21,
  "煦": 13,
  "蓄": 16,
  "轩": 10,
  "宣": 9,
  "喧": 13,
  "萱": 15,
  "暄": 13,
  "玄": 5,
  "悬": 20,
  "旋": 11,
  "漩": 15,
  "璇": 16,
  "选": 19,
  "镟": 19,
  "薛": 19,
  "穴": 5,
  "学": 16,
  "雪": 11,
  "血": 6,
  "勋": 16,
  "熏": 14,
  "薰": 20,
  "旬": 6,
  "巡": 7,
  "询": 12,
  "洵": 10,
  "训": 10,
  "汛": 7,
  "迅": 10,
  "徇": 8,
  "押": 9,
  "牙": 4,
  "芽": 10,
  "涯": 12,
  "衙": 13,
  "雅": 12,
  "亚": 8,
  "烟": 9,
  "嫣": 14,
  "严": 20,
  "言": 7,
  "岩": 8,
  "沿": 9,
  "炎": 8,
  "研": 7,
  "衍": 9,
  "掩": 12,
  "眼": 11,
  "琰": 12,
  "演": 15,
  "彦": 9,
  "砚": 12,
  "宴": 10,
  "晏": 10,
  "艳": 11,
  "验": 23,
  "焰": 12,
  "焱": 12,
  "雁": 12,
  "滟": 28,
  "央": 5,
  "秧": 10,
  "鞅": 14,
  "扬": 13,
  "羊": 6,
  "阳": 17,
  "杨": 13,
  "佯": 8,
  "洋": 10,
  "仰": 6,
  "养": 15,
  "样": 15,
  "妖": 15,
  "腰": 15,
  "邀": 20,
  "姚": 9,
  "摇": 14,
  "瑶": 15,
  "杳": 8,
  "要": 9,
  "钥": 25,
  "耀": 20,
  "椰": 13,
  "爷": 13,
  "也": 3,
  "冶": 7,
  "野": 11,
  "业": 13,
  "叶": 15,
  "页": 9,
  "夜": 8,
  "液": 12,
  "谒": 16,
  "一": 1,
  "伊": 6,
  "衣": 6,
  "医": 18,
  "依": 8,
  "仪": 15,
  "夷": 6,
  "诒": 12,
  "宜": 8,
  "怡": 9,
  "姨": 9,
  "贻": 12,
  "移": 10,
  "遗": 19,
  "彝": 18,
  "乙": 1,
  "以": 5,
  "蚁": 19,
  "倚": 10,
  "椅": 12,
  "义": 13,
  "亿": 15,
  "弋": 3,
  "忆": 17,
  "艺": 21,
  "议": 20,
  "亦": 6,
  "屹": 6,
  "异": 12,
  "役": 7,
  "抑": 8,
  "译": 20,
  "邑": 7,
  "易": 8,
  "诣": 13,
  "驿": 23,
  "奕": 9,
  "轶": 12,
  "益": 10,
  "谊": 15,
  "翌": 11,
  "逸": 15,
  "意": 13,
  "溢": 14,
  "肄": 13,
  "裔": 13,
  "毅": 15,
  "熠": 15,
  "镒": 18,
  "薏": 19,
  "翼": 18,
  "臆": 19,
  "懿": 20,
  "因": 6,
  "阴": 16,
  "姻": 9,
  "茵": 12,
  "荫": 17,
  "音": 9,
  "吟": 7,
  "寅": 11,
  "银": 14,
  "尹": 4,
  "引": 4,
  "饮": 14,
  "隐": 22,
  "印": 6,
  "胤": 9,
  "应": 17,
  "英": 11,
  "莺": 21,
  "婴": 17,
  "瑛": 14,
  "缨": 23,
  "樱": 21,
  "璎": 22,
  "鹦": 28,
  "膺": 19,
  "鹰": 24,
  "迎": 11,
  "盈": 9,
  "莹": 13,
  "萤": 16,
  "营": 17,
  "赢": 17,
  "瀛": 20,
  "郢": 14,
  "颍": 15,
  "颖": 16,
  "影": 15,
  "映": 9,
  "拥": 17,
  "庸": 11,
  "雍": 13,
  "鳙": 22,
  "永": 5,
  "咏": 8,
  "泳": 9,
  "勇": 9,
  "涌": 13,
  "优": 17,
  "忧": 15,
  "幽": 9,
  "悠": 11,
  "尤": 4,
  "由": 5,
  "犹": 13,
  "邮": 15,
  "油": 9,
  "游": 13,
  "友": 4,
  "有": 6,
  "酉": 7,
  "莠": 13,
  "又": 2,
  "右": 5,
  "幼": 5,
  "侑": 8,
  "柚": 9,
  "诱": 14,
  "于": 3,
  "余": 7,
  "於": 8,
  "鱼": 11,
  "俞": 9,
  "娱": 10,
  "馀": 16,
  "渔": 15,
  "渝": 13,
  "逾": 16,
  "榆": 13,
  "瑜": 14,
  "虞": 13,
  "舆": 17,
  "宇": 6,
  "屿": 17,
  "禹": 9,
  "语": 14,
  "圉": 11,
  "玉": 5,
  "聿": 6,
  "育": 10,
  "郁": 13,
  "昱": 9,
  "狱": 17,
  "峪": 10,
  "浴": 11,
  "钰": 13,
  "预": 13,
  "欲": 11,
  "谕": 16,
  "喻": 12,
  "寓": 12,
  "裕": 13,
  "煜": 13,
  "蓣": 19,
  "誉": 21,
  "豫": 16,
  "鸢": 21,
  "渊": 12,
  "元": 4,
  "员": 10,
  "园": 13,
  "沅": 8,
  "原": 10,
  "圆": 13,
  "袁": 10,
  "援": 13,
  "缘": 15,
  "源": 14,
  "苑": 11,
  "院": 15,
  "媛": 12,
  "瑗": 14,
  "愿": 14,
  "约": 9,
  "月": 4,
  "岳": 8,
  "悦": 11,
  "阅": 15,
  "跃": 21,
  "越": 12,
  "晕": 13,
  "云": 12,
  "匀": 4,
  "芸": 10,
  "昀": 8,
  "耘": 10,
  "筠": 13,
  "允": 4,
  "运": 16,
  "韫": 19,
  "韵": 19,
  "熨": 15,
  "蕴": 22,
  "匝": 5,
  "哉": 9,
  "栽": 10,
  "宰": 10,
  "再": 6,
  "在": 6,
  "载": 13,
  "咱": 9,
  "暂": 15,
  "赞": 19,
  "早": 6,
  "澡": 17,
  "灶": 7,
  "皂": 7,
  "造": 14,
  "则": 9,
  "择": 17,
  "泽": 17,
  "责": 11,
  "增": 15,
  "甑": 16,
  "眨": 12,
  "栅": 9,
  "炸": 10,
  "摘": 15,
  "宅": 6,
  "寨": 14,
  "旃": 10,
  "詹": 13,
  "谵": 20,
  "展": 10,
  "崭": 14,
  "辗": 17,
  "占": 5,
  "战": 16,
  "栈": 12,
  "站": 10,
  "张": 11,
  "彰": 14,
  "樟": 15,
  "璋": 14,
  "长": 8,
  "涨": 15,
  "掌": 12,
  "丈": 3,
  "仗": 5,
  "帐": 11,
  "杖": 7,
  "嶂": 14,
  "招": 9,
  "昭": 9,
  "召": 5,
  "兆": 6,
  "赵": 14,
  "遮": 18,
  "折": 7,
  "哲": 10,
  "者": 10,
  "这": 14,
  "浙": 11,
  "蔗": 17,
  "贞": 9,
  "针": 10,
  "侦": 11,
  "帧": 12,
  "珍": 10,
  "桢": 13,
  "真": 10,
  "砧": 10,
  "祯": 14,
  "斟": 13,
  "甄": 14,
  "箴": 15,
  "臻": 16,
  "诊": 12,
  "枕": 8,
  "轸": 12,
  "圳": 6,
  "阵": 15,
  "振": 11,
  "朕": 10,
  "镇": 18,
  "震": 15,
  "争": 8,
  "征": 8,
  "峥": 11,
  "铮": 16,
  "筝": 14,
  "蒸": 16,
  "拯": 10,
  "整": 12,
  "正": 5,
  "证": 19,
  "诤": 15,
  "郑": 19,
  "政": 8,
  "之": 4,
  "支": 4,
  "芝": 10,
  "枝": 8,
  "知": 8,
  "织": 18,
  "执": 11,
  "侄": 8,
  "直": 8,
  "值": 10,
  "职": 18,
  "植": 12,
  "殖": 12,
  "止": 4,
  "只": 5,
  "旨": 6,
  "纸": 10,
  "芷": 18,
  "祉": 9,
  "指": 10,
  "趾": 11,
  "徵": 15,
  "至": 6,
  "志": 7,
  "制": 8,
  "帙": 8,
  "帜": 15,
  "治": 9,
  "炙": 8,
  "质": 15,
  "峙": 9,
  "秩": 10,
  "致": 9,
  "痔": 9,
  "智": 12,
  "置": 14,
  "中": 4,
  "忠": 8,
  "终": 11,
  "盅": 9,
  "钟": 17,
  "种": 14,
  "仲": 6,
  "重": 9,
  "州": 6,
  "舟": 6,
  "周": 8,
  "洲": 10,
  "妯": 8,
  "纣": 9,
  "宙": 8,
  "朱": 6,
  "侏": 8,
  "株": 10,
  "珠": 11,
  "诸": 16,
  "猪": 16,
  "竹": 6,
  "竺": 8,
  "烛": 17,
  "主": 5,
  "渚": 13,
  "煮": 13,
  "住": 7,
  "助": 7,
  "杼": 8,
  "注": 9,
  "贮": 13,
  "驻": 15,
  "柱": 9,
  "炷": 9,
  "祝": 10,
  "著": 15,
  "筑": 16,
  "铸": 22,
  "专": 11,
  "转": 18,
  "赚": 16,
  "撰": 16,
  "妆": 7,
  "庄": 13,
  "装": 13,
  "壮": 7,
  "状": 8,
  "谆": 15,
  "准": 10,
  "拙": 9,
  "捉": 11,
  "桌": 10,
  "卓": 8,
  "酌": 10,
  "镯": 21,
  "兹": 10,
  "咨": 9,
  "姿": 9,
  "资": 13,
  "滋": 14,
  "子": 3,
  "仔": 5,
  "紫": 11,
  "字": 6,
  "自": 6,
  "宗": 8,
  "综": 14,
  "总": 17,
  "纵": 17,
  "邹": 17,
  "奏": 9,
  "租": 10,
  "足": 7,
  "卒": 8,
  "族": 11,
  "镞": 19,
  "阻": 13,
  "组": 11,
  "祖": 10,
  "钻": 23,
  "醉": 15,
  "遵": 19,
  "昨": 9,
  "左": 5,
  "佐": 7,
  "作": 7,
  "坐": 7,
  "座": 10,
  "做": 11,
} as Record<string, number>;

export const lookupNameologyStroke = (char: string): number => {
  const key = Array.from(String(char || '').trim())[0] || '';
  if (!key) return 0;
  const stroke = Number(NAMEOLOGY_STROKE_MAP[key] || 0);
  return Number.isFinite(stroke) && stroke > 0 ? Math.trunc(stroke) : 0;
};
